import React, { useState, useEffect } from "react";
import MultiRangeSlider from "multi-range-slider-react";
import "../../../index.css";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useNavigate } from "react-router-dom";
import GoogleMap from "./Google-map";
import GgleMap from "./Google-map";
import MapComponent from "./Google-map";
import { useTranslation } from "react-i18next";

const alarmTypes = [
  { name: "Info", value: "info" },
  { name: "Warning", value: "warning" },
  { name: "Critical", value: "critical" },
];
const AlarmSettings = ({
  alarmPopup,
  setAlarmPopup,
  selectedParameter,
  setAsset,
  setState,
  selectedAlarm,
}) => {
  const { t } = useTranslation();
  const defaultAlarm = {
    id: 0,
    alarmName: "",
    infoEnabled: false,
    warningEnabled: false,
    criticalEnabled: false,
    infoMinRange: 0,
    infoMaxRange: 100,
    infoInverse: false,
    warningInverse: false,
    criticalInverse: false,
    warningMinRange: 0,
    warningMaxRange: 100,
    criticalMinRange: 0,
    criticalMaxRange: 100,
    signalType: 100,
    alarmSensorId: "",
    sensorName: "",
    infoSensorValue: "",
    infoAlarmText: "",
    warningSensorValue: "",
    warningAlarmText: "",
    criticalSensorValue: "",
    criticalAlarmText: "",
    infoKMRange: 0,
    warningKMRange: 0,
    criticalKMRange: 0,
    polygonCoordinates: [],
  };
  const booleanData = [
    { id: 1, value: "True" },
    { id: 0, value: "False" },
  ];
  const [alarm, setAlarm] = useState(defaultAlarm);
  const [sliderValue, setSliderValue] = useState({
    minor: { min: 0, max: 100 },
    major: { min: 0, max: 100 },
    critical: { min: 0, max: 100 },
  });

  const handleAnalogButtonClick = (e) => {
    setAlarm((pre) => ({
      ...pre,
      signalType: 100,
    }));
  };

  const handleDigitalButtonClick = () => {
    setAlarm((pre) => ({
      ...pre,
      signalType: 200,
    }));
  };

  const handleSliderChange = (e, name) => {
    setAlarm((pre) => ({
      ...pre,
      // critical: {
      //   minValue: e.minValue,
      //   maxValue: e.maxValue,
      // },
      [name + "LowerLimit"]: e.minValue,
      [name + "UpperLimit"]: e.maxValue,
    }));
    setSliderValue((pre) => ({
      ...pre,
      [name]: {
        minValue: e.minValue,
        maxValue: e.maxValue,
      },
    }));
  };

  const onRangeChange = (e) => {
    setAlarm((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
  };

  const onInverseCheckBoxChange = (e) => {
    setAlarm((pre) => ({
      ...pre,
      [e.target.name]: !alarm[e.target.name],
    }));
  };

  const onHandleChange = (e) => {
    setAlarm((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };

  const onCloseClick = (e) => {
    // navigate(`/alarmList`);
  };

  const handleComboBoxChange = (event) => {
    setAlarm({
      ...alarm,
      [event.target.name]: event.value.value,
      [event.target.name + "Data"]: event.value,
    });
  };

  const onAlarmImport = () => {
    const newAlarm = {
      ...alarm,
      parameterId: selectedParameter.alarmParentId,
      parameterType: selectedParameter.type,
    };

    setState((pre) => ({
      ...pre,
      alarms:
        selectedAlarm === null
          ? pre.alarms
            ? [...pre.alarms, newAlarm]
            : [newAlarm]
          : pre.alarms.map((a, i) =>
              i === selectedAlarm.index ? { ...alarm } : a
            ),
    }));

    setAlarmPopup();
  };

  useEffect(() => {
    if (selectedParameter && selectedParameter.type === "Boolean") {
      handleDigitalButtonClick();
    } else {
      handleAnalogButtonClick();
    }
    if (selectedAlarm !== null && selectedAlarm !== undefined) {
      if (selectedParameter?.type === "Boolean") {
        setAlarm({
          ...selectedAlarm,
          infoSensorValueData: booleanData.find(
            (bd) => bd.value === selectedAlarm.infoSensorValue
          ),
          warningSensorValueData: booleanData.find(
            (bd) => bd.value === selectedAlarm.warningSensorValue
          ),
          criticalSensorValueData: booleanData.find(
            (bd) => bd.value === selectedAlarm.criticalSensorValue
          ),
        });
      } else {
        setAlarm({ ...selectedAlarm });
      }
      setSliderValue({
        ...selectedAlarm,
        info: {
          minValue: selectedAlarm.infoLowerLimit,
          maxValue: selectedAlarm.infoUpperLimit,
        },
        warning: {
          minValue: selectedAlarm.warningLowerLimit,
          maxValue: selectedAlarm.warningUpperLimit,
        },
        critical: {
          minValue: selectedAlarm.criticalLowerLimit,
          maxValue: selectedAlarm.criticalUpperLimit,
        },
      });
    }
  }, []);
  
  const renderInput = (
    label,
    name,
    type,
    data = null,
    showInverse,
    inverseName
  ) => {
    const inputValue = alarm[name];
    const inverseValue = alarm[inverseName];
    return (
      <div className="flex gap-4 text-gray-100 items-center w-full">
        <label className="w-24">{label}</label>
        {type === "number" ? (
          <input
            type="number"
            name={name}
            max={alarm[`${name}MaxRange`]}
            className="bg-[#363945] rounded-lg h-8 pl-5"
            value={inputValue}
            onChange={onRangeChange}
          />
        ) : type === "string" ? (
          <div className="flex gap-2 items-center ">
            <input
              type="text"
              name={name}
              className="bg-[#363945] rounded-lg w-[265px] h-9 pl-3"
              value={inputValue}
              onChange={onRangeChange}
            />
            {showInverse ? (
              <button
                className={`flex gap-2 items-center justify-center text-base font-medium h-9 w-9 ${
                  inverseValue ? "bg-blue-600" : "bg-green-600"
                } rounded-md`}
                name={inverseName}
                onClick={onInverseCheckBoxChange}
              >
                {inverseValue ? "!=" : "=="}
              </button>
            ) : null}
          </div>
        ) : type === "boolean" && data ? (
          <div className="flex">
            <ComboBox
              data={data}
              dataItemKey="id"
              textField="value"
              name={name}
              style={{ fontWeight: 500 }}
              suggest={true}
              clearButton={false}
              className="block placeholder:text-white border-grey-light text-white rounded-lg h-9"
              onChange={(e) => handleComboBoxChange(e)}
              value={alarm[`${name}Data`]}
            />
          </div>
        ) : type === "geolocation" ? (
          <input
            type="number"
            name={name}
            className="bg-[#363945] rounded-lg h-8 pl-5"
            value={inputValue}
            onChange={onRangeChange}
          />
        ) : null}
      </div>
    );
  };

  return (
    <div
      className={`px-14 py-5 flex flex-col dark:text-white text-black rounded-md dark:bg-neutral-900 bg-lightModePopup gap-5 ${
        alarmPopup ? "h-[92vh] w-[80vw]" : "h-[92vh]"
      } `}
    >
      {alarmPopup ? (
        <div className="flex gap-3 text-lg font-medium justify-between items-center">
          {t("masters.fields.import_alarm")}
          <button type="button" onClick={() => setAlarmPopup()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      ) : (
        <div className="flex gap-3 text-xs font-medium items-center">
          <button type="button" onClick={onCloseClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.0"
              stroke="currentColor"
              class="w-7 h-7"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          {t("masters.fields.alarm_settings")}
        </div>
      )}
      <div className="flex gap-3 items-center text-sm font-medium dark:text-gray-100 text-black">
        <div className="flex items-center gap-3">
          <label className="dark:text-gray-100 text-black">{t("masters.fields.alrmName")}</label>
          <input
            type="text"
            placeholder="Alarm name"
            name="alarmName"
            className="dark:bg-[#363945] bg-lightModePopupBtn placeholder:dark:text-gray-100 placeholder:text-black rounded-lg h-8 pl-5"
            value={alarm.alarmName}
            onChange={onHandleChange}
          />
        </div>
      </div>

      <div className="overflow-y-scroll overflow-x-hidden h-4/5 flex flex-col gap-5 pb-5">
        {selectedParameter?.type === "GeoLocation" && (
          <div className="h-full">
            <MapComponent setAlarm={setAlarm} alarm={alarm} />
          </div>
        )}
        {alarmTypes.map((at) => (
          <div className="px-6 py-8 dark:bg-zinc-900 bg-lightModePopupBtn">
            <div className="flex gap-5">
              <label className="w-20">{at.name}</label>
              <div
                className={`inline-flex rounded-xl group mt-1 h-7 border-2 ${
                  alarm[at.value + "Enabled"]
                    ? "bg-lime-700 border-lime-700 text-white"
                    : "bg-white border-white"
                }`}
              >
                <button
                  type="button"
                  className={`text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                    alarm[at.value + "Enabled"]
                      ? "bg-lime-700 text-white"
                      : "text-lime-700 rounded-full bg-lime-700"
                  }`}
                  onClick={() =>
                    setAlarm((prev) => ({
                      ...prev,
                      [at.value + "Enabled"]: !prev[at.value + "Enabled"],
                    }))
                  }
                >
                  {t("masters.fields.on")}
                </button>
                <button
                  type="button"
                  className={`bg-white text-xs font-medium text-center rounded-xl w-1/2 px-2 ${
                    alarm[at.value + "Enabled"]
                      ? "bg-white text-white rounded-full"
                      : "text-black"
                  }`}
                  onClick={() =>
                    setAlarm((prev) => ({
                      ...prev,
                      [at.value + "Enabled"]: !prev[at.value + "Enabled"],
                    }))
                  }
                >
                  {t("masters.fields.off")}
                </button>
              </div>
            </div>
            {alarm[at.value + "Enabled"] &&
              selectedParameter?.type === "Number" && (
                <div className="flex gap-12 mt-10 text-xs font-medium">
                  {renderInput("MIN", at.value + "MinRange", "number")}
                  {renderInput("MAX", at.value + "MaxRange", "number")}
                </div>
              )}
            {alarm[at.value + "Enabled"] &&
              selectedParameter?.type === "GeoLocation" && (
                <div className="flex gap-12 mt-10 text-xs font-medium">
                  {renderInput(
                    "Alarm Range (KM)",
                    at.value + "KMRange",
                    "geolocation"
                  )}
                </div>
              )}
            {alarm[at.value + "Enabled"] === true &&
              selectedParameter?.type === "String" && (
                <div className="flex gap-12 mt-10 text-xs font-medium">
                  {renderInput(
                    "Sensor Value",
                    at.value + "SensorValue",
                    "string",
                    null,
                    true,
                    at.value + "Inverse"
                  )}
                </div>
              )}

            {alarm[at.value + "Enabled"] === true &&
              selectedParameter?.type === "Boolean" && (
                <div className="flex gap-12 mt-10 text-xs font-medium">
                  {renderInput(
                    "Sensor Value",
                    at.value + "SensorValue",
                    "boolean",
                    booleanData
                  )}
                </div>
              )}

            {alarm[at.value + "Enabled"] === true &&
              selectedParameter?.type === "Number" && (
                <div
                  className="mt-6 flex w-full items-center gap-6 text-xs font-medium dark:text-gray-100 text-black"
                  id={at.value}
                >
                  <div className="dark:text-gray-100 text-black">
                    {t("masters.fields.lower_limit")}
                  </div>
                  <div className="w-2/3">
                    <MultiRangeSlider
                      ruler={false}
                      min={alarm[at.value + "MinRange"]}
                      max={alarm[at.value + "MaxRange"]}
                      step={2}
                      minValue={sliderValue[at.value]?.minValue}
                      maxValue={sliderValue[at.value]?.maxValue}
                      onChange={(e) => handleSliderChange(e, at.value)}
                    />
                  </div>
                  <div className="dark:text-gray-100 text-black">
                    {t("masters.fields.upper_limit")}
                  </div>
                  <div className="h-9 flex items-center dark:text-slate-500 text-white px-6 py-2 bg-zinc-700 rounded-lg">
                    <div>
                      {t("masters.fields.lower_limit")} :{" "}
                      {sliderValue[at.value]?.minValue}
                    </div>
                    <hr className="rotate-90 w-4 border-slate-500 border-l" />
                    <div>
                      {t("masters.fields.upper_limit")} :{" "}
                      {sliderValue[at.value]?.maxValue}
                    </div>
                  </div>
                </div>
              )}

            {/* {alarm[at.value + "Enabled"] === true &&
              (selectedParameter?.type === "String" ||
                selectedParameter?.type === "Boolean") && (
                <div className="flex gap-12 mt-10 text-xs font-medium">
                  {renderInput(
                    "Alarm Text",
                    at.value + "AlarmText",
                    "string",
                    null,
                    false,
                    at.value + "Inverse"
                  )}
                </div>
              )} */}
          </div>
        ))}
      </div>

      {alarmPopup ? (
        <div className="flex justify-end items-center w-full gap-2 text-black font-medium text-sm">
          <button
            className="h-9 w-20 bg-zinc-200 rounded-4xl"
            type="button"
            onClick={() => setAlarmPopup()}
          >
            {t("button.cancel")}
          </button>
          <button
            type="button"
            className="h-9 px-3 bg-indigo-500 rounded-4xl disabled:opacity-40"
            onClick={onAlarmImport}
            disabled={alarm.alarmName === ""}
          >
            {selectedAlarm !== null && selectedAlarm !== undefined
              ? `${t("masters.fields.update_alarm")}`
              : `${t("button.save")}`}
          </button>
        </div>
      ) : (
        <div className="flex justify-end items-center w-full gap-2 text-black font-medium text-sm">
          <button
            className="h-9 w-20 dark:bg-zinc-200 bg-closeBtns dark:text-black  text-closeBtnTxts rounded-4xl"
            type="button"
            onClick={onCloseClick}
          >
            {t("button.cancel")}
          </button>
          <button className="h-9 w-20 dark:bg-indigo-500 bg-submitBtns rounded-4xl">
            {t("button.save")}
          </button>
        </div>
      )}
    </div>
  );
};

export default AlarmSettings;
